import styled from 'styled-components';
export var Type = styled.small.withConfig({
  displayName: "Type",
  componentId: "sc-1d6wi67-0"
})(["padding-bottom:3px;color:", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.fontL;
});